import styled from 'styled-components';
import { colors, spacing, Caption, Body2Bold } from 'ui/theme';
import { AppPlatform } from 'modules/mobileApps/types';
import { Apple24, Android24 } from 'ui/icons';
import { ApplicationOverflowMenu } from './ApplicationOverflowMenu';
import { CustomMTAMobileApp } from '../../../types';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const Details = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.quarter};
`;

const Name = styled(Body2Bold)`
  margin-bottom: 0;
`;

export const ApplicationRow = ({
  customMtaMobileApp,
}: {
  customMtaMobileApp: CustomMTAMobileApp;
}) => {
  return (
    <Wrapper key={customMtaMobileApp.id}>
      <Details>
        {customMtaMobileApp.platform === AppPlatform.IOS ? (
          <Apple24 color={colors.textSecondary} />
        ) : (
          <Android24 color={colors.textSecondary} />
        )}
        <Name>{customMtaMobileApp.name}</Name>
        <Caption>{customMtaMobileApp.storeUrl}</Caption>
      </Details>
      <ApplicationOverflowMenu />
    </Wrapper>
  );
};
